module.exports = __webpack_public_path__ + "./img/archer.c36d6dd0d87b9002968ec439ae1ad263.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/Pages/Login/archer.png
// module id = ./src/views/Pages/Login/archer.png
// module chunks = 0